import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useAuth } from "./AuthProvider";
import { isAdminRole } from "@/lib/permissions";

export function ProtectedRoute() {
  const { status, identity } = useAuth();
  const location = useLocation();

  if (status === "loading") {
    return (
      <div className="flex h-screen items-center justify-center text-muted-foreground">
        Loading…
      </div>
    );
  }

  if (status !== "signed_in" || !identity) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  if (!isAdminRole(identity.role)) {
    return <Navigate to="/wrong-app" replace />;
  }

  return <Outlet />;
}
